const insight = {
  ISSUE_MENTION_LIST: ['ISSUE_MENTION_LIST'] as const,
  ISSUE_TRENDING_LIST: ['ISSUE_TRENDING_LIST'] as const,
  DELETED_ISSUE_LIST: ['DELETED_ISSUE_LIST'] as const,
  ISSUE_DETAIL_SEGMENT_TREND: ['ISSUE_DETAIL_SEGMENT_TREND'] as const,
  ISSUE_DETAIL_SEGMENT_CUSTOMER_LIST: ['ISSUE_DETAIL_SEGMENT_CUSTOMER_LIST'] as const,
};

export default insight;
